/* import react, firebase, firestore, and UI methods*/
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {FaHeart,FaRegHeart} from 'react-icons/fa';
import {UserAuth} from '../context/AuthContext';
import {db} from '../firebase'
import {arrayUnion, doc, updateDoc} from 'firebase/firestore'

//This is the component for thumbnail of a movie in the rows
const Movie = ({item}) => {

    //'like' is used to show if the user has liked the movie, tv show.
    const [like,setLike] = useState(false);
    
    //'saved' is used to update the firestore document.
    const [saved, setSaved] = useState(false);

    //consumes user context values from AuthContextProvider
    const {user} = UserAuth();

    //reference to the user's document in firestore database.
    const movieID = doc(db,'users',`${user?.email}`)

    //function to handle the 'like' click
    const saveShow = async() =>{

        //check if the user is logged in
        if(user?.email) {

            setLike(!like)
            setSaved(true)

            //add the movie, show to the document array with 
            // an object as user id, title of the movie/tv show, image of the 
            //movie/tv show as the keys.
            await updateDoc(movieID,{
                savedShows: arrayUnion({
                    id:item.id,
                    title:item.title,
                    img:item.backdrop_path
                })
            })
        }
        //alert the user to login.
        else{
            alert('Please log in to save a movie');
        }
    }

  //return the thumbnail
  return (
    <div className='w-[160px] sm:w-[200px] md:w-[240px] lg:w-[280px] inline-block cursor-pointer relative p-2'>
        <img className="w-full h-auto block" src={`https://image.tmdb.org/t/p/w500/${item?.backdrop_path}`} alt={item?.title} />
            <div className="absolute top-0 left-0 w-full h-full hover:bg-black/80 opacity-0 hover:opacity-100 text-white">
                <p className='white-space-normal text-xs :md:text-sm font-bold flex justify-center items-center h-full text-center'>
                    {item?.title}
                </p>
                {/* handle the 'like' button click.*/}
                <p onClick={saveShow}>
                    {like?<FaHeart className='absolute top-4 left-4 text-gray-300'/>:<FaRegHeart className='absolute top-4 left-4 text-gray-300'/>}
                </p>
            </div>
    </div>
  )
}

export default Movie